<template>
    <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.92969 16.1421L9.00076 9.07102L1.92969 1.99995" stroke="#3D9E98" stroke-width="2" stroke-linecap="square"/>
    </svg>
</template>